/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_DescriptionInputs */

const en_plain_text_import_description = /** @type {(inputs: Plain_Text_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import plain text and configure import settings`)
};

const fr_plain_text_import_description = /** @type {(inputs: Plain_Text_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer du texte brut et configurer les parametres d'importation`)
};

const de_plain_text_import_description = /** @type {(inputs: Plain_Text_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klartext importieren und Importeinstellungen konfigurieren`)
};

const it_plain_text_import_description = /** @type {(inputs: Plain_Text_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa testo normale e configura le impostazioni di importazione`)
};

const ru_plain_text_import_description = /** @type {(inputs: Plain_Text_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импортируйте текстовый файл и настройте параметры импорта.`)
};

const es_plain_text_import_description = /** @type {(inputs: Plain_Text_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar texto sin formato y configurar los ajustes de importación`)
};

const zh_cn2_plain_text_import_description = /** @type {(inputs: Plain_Text_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入纯文本并配置导入设置`)
};

const ja_plain_text_import_description = /** @type {(inputs: Plain_Text_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレーンテキストをインポートし、インポート設定を構成する`)
};

const hi_plain_text_import_description = /** @type {(inputs: Plain_Text_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साधारण टेक्स्ट आयात करें और आयात सेटिंग्स कॉन्फ़िगर करें`)
};

const pt_pt2_plain_text_import_description = /** @type {(inputs: Plain_Text_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe texto simples e configure as opções de importação.`)
};

/**
* | output |
* | --- |
* | "Import plain text and configure import settings" |
*
* @param {Plain_Text_Import_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_description = /** @type {((inputs?: Plain_Text_Import_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_description(inputs)
	if (locale === "de") return de_plain_text_import_description(inputs)
	if (locale === "it") return it_plain_text_import_description(inputs)
	if (locale === "ru") return ru_plain_text_import_description(inputs)
	if (locale === "es") return es_plain_text_import_description(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_description(inputs)
	if (locale === "ja") return ja_plain_text_import_description(inputs)
	if (locale === "hi") return hi_plain_text_import_description(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_description(inputs)
	return en_plain_text_import_description(inputs)
});